import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ReviewDetailTab } from "@/features/review-queue/types";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ReviewDetailPage } from "@/features/review-queue/detail/review-detail-page";
import {
  REVIEW_DETAIL_TAB,
  REVIEW_DETAIL_TAB_VALUES,
} from "@/features/review-queue/types";

const reviewDetailTabTuple = REVIEW_DETAIL_TAB_VALUES as [
  ReviewDetailTab,
  ...ReviewDetailTab[],
];

export const Route = createFileRoute("/review-queue/$actionId")({
  validateSearch: z.object({
    tab: z.enum(reviewDetailTabTuple).optional().catch(REVIEW_DETAIL_TAB.OVERVIEW),
  }),
  component: () => (
    <PermissionGuard module="review_queue">
      <ReviewDetailPage />
    </PermissionGuard>
  ),
});
